<script>
    import { page } from '$app/stores';
    import { onMount } from 'svelte';
    import { img_cdn } from './utils/image';
    import Icon from './Icon.svelte';
    import { site_origin } from './stores/globals';

    export let sm = false;
    let className = '';
    export { className as class };

    /** @type {string}*/
    export let text = $page.data.head_description || '';
    /** @type {string}*/
    export let url;
    /** @type {string}*/
    export let img;

    let x_id = 'critikids';
    let copied = false;

    let can_share = false;

    onMount(() => {
        if (navigator.share) {
            can_share = true;
        }
    });

    // console.log(url, img);

    const copy_link = () => {
        navigator.clipboard.writeText(url);
        copied = true;
    };

    /**
     * @param {Object} options
     * @param {string=} options.text
     * @param {string=} options.url
     * @param {string=} options.img
     */
    const share = async ({ text, url, img }) => {
        try {
            let files = [];
            if (img) {
                const blob = await fetch(`${img}`).then((r) => r.blob());

                files.push(
                    new File([blob], 'image.png', { type: 'image/png' })
                );
            }

            let share_data = {};
            if (text) share_data.text = text;
            if (url) share_data.url = url;
            if (files.length) share_data.files = files;

            if (navigator?.canShare(share_data)) {
                await navigator.share(share_data);
            } else {
                can_share = false;
                alert('Failed to share, please try again.');
            }
        } catch (error) {
            if (!(error.name && error.name == 'AbortError')){
                alert('Failed to share, please try again.');
            }
        }
    };
</script>

<div class="flex nowrap mx-auto gap-4 items-center max-w-md {className}">
    <slot />

    <button
        type="button"
        class="opacity-80 hover:opacity-100 transition-opacity"
        on:click={copy_link}
    >
        <Icon link class="aspect-square {sm ? 'w-6' : 'w-8'}" />
        {#if copied}
            Copied!
        {/if}
    </button>

    {#if can_share}
        <button
            type="button"
            class="opacity-80 hover:opacity-100 transition-opacity"
            on:click={() => share({ text, url })}
        >
            <img
                src={img_cdn('/logo-fb.svg')}
                alt="Facebook"
                class="aspect-square {sm ? 'w-6' : 'w-8'}"
                loading="lazy"
            />
        </button>

        <button
            type="button"
            class="opacity-80 hover:opacity-100 transition-opacity"
            on:click={() => share({ text: `${text} ${'@' + x_id}`, url })}
        >
            <img
                src={img_cdn('/logo-x.svg')}
                alt="X"
                class="aspect-square {sm ? 'w-6' : 'w-8'}"
                loading="lazy"
            />
        </button>

        <button
            type="button"
            class="opacity-80 hover:opacity-100 transition-opacity"
            on:click={() => share({ img })}
            ><img
                src={img_cdn('/logo-instagram.svg')}
                alt="Instagram"
                class="aspect-square {sm ? 'w-6' : 'w-8'}"
                loading="lazy"
            /></button
        >
    {:else}
        <a
            href="https://www.facebook.com/sharer/sharer.php?u={url}&text={text}"
            class="opacity-80 hover:opacity-100 transition-opacity"
            target="_blank"
            ><img
                src={img_cdn('/logo-fb.svg')}
                alt="Facebook"
                class="aspect-square {sm ? 'w-6' : 'w-8'}"
                loading="lazy"
            /></a
        >

        <a
            href="https://twitter.com/intent/post?original_referer={site_origin}&text={text}&url={url}&via={x_id}"
            target="_blank"
            class="opacity-80 hover:opacity-100 transition-opacity"
            ><img
                src={img_cdn('/logo-x.svg')}
                alt="X"
                class="aspect-square {sm ? 'w-6' : 'w-8'}"
                loading="lazy"
            /></a
        >
    {/if}
</div>
